import styled from 'styled-components';

import Page from 'components/layouts/page/Page';
import FilterChips from 'components/shared/FilterChips';
import DesktopOnly from 'components/shared/responsiveness/DesktopOnly';
import FilterValueArray from 'models/filterValues/FilterValueArray';
import { useInboundReferralsInsightsStore } from 'stores/inboundReferralsInsightsStore';

import InboundReferralsFilterBar from './filterBar/InboundReferralsFilterBar';
import InboundReferralsDashboard from './InboundReferralsDashboard';

// Unlike the outbound Referrals dashboard, inbound isn't organized by sending/receiving
// group-type tabs (it's scoped to the user's SNFs), so it uses a purpose-built store instead
// of createInsightsDashboardContainer.
export default function InboundReferralsInsightsPage() {
  const filters = useInboundReferralsInsightsStore((state) => state.filters);

  const chippableFilters = Object.entries(filters).reduce((acc, [key, value]) => {
    if (value instanceof FilterValueArray && value.length > 0) {
      return { ...acc, [key]: value };
    }
    return acc;
  }, {});

  return (
    <Page>
      <StyledPageHeader>
        <InboundReferralsFilterBar />
      </StyledPageHeader>
      <Page.SubHeader>
        <DesktopOnly>
          <FilterChips filters={chippableFilters} useStore={useInboundReferralsInsightsStore} />
        </DesktopOnly>
      </Page.SubHeader>
      <Page.Content>
        <InboundReferralsDashboard />
      </Page.Content>
    </Page>
  );
}

const StyledPageHeader = styled(Page.Header)`
  background: none;
  border-bottom: none;
`;
